<template>
  <form class="form" @submit.prevent="onSave">
    <div class="form__head">
      <div class="form__title form__title_white mb10">
        <span>Update comment or files</span>
        <button type="reset" class="close-btn" @click="$emit('close')">
          <img src="@/assets/images/close.svg" width="24px" alt />
        </button>
      </div>
    </div>

    <div class="form__content">
      <div class="form-item mb16">
        <el-input
          type="textarea"
          :rows="5"
          :placeholder="$t('forms.description')"
          v-model="form.description"
          ref="description"
        ></el-input>
      </div>

      <div class="form-item mb10">
        <upload-image @onChange="filesUploaded" />
      </div>

      <div class="form-item">
        <button class="btn btn_width btn_mobile-width-100">{{ $t("buttons.save") }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import uploadImage from "@/components/forms/uploadImage";

export default {
  name: "edit-comment-and-files",
  components: {
    uploadImage
  },
  props: {
    description: {
      required: false,
      default: ""
    },
    id: {
      required: true
    }
  },
  data() {
    return {
      form: {
        description: ""
      },
      images: [],
      files: []
    };
  },
  computed: {
    hasDescriptionChanges() {
      return this.form.description != this.description;
    },
    hasImagesUploaded() {
      return this.images.length > 0;
    },
    hasFilesUploaded() {
      return this.files.length > 0;
    }
  },
  methods: {
    ...mapActions({
      updateDescription: "orders/updateDescription",
      ordersImageUpload: "orders/uploadImage",
      addFiles: "orders/addFiles"
    }),
    initForm() {
      this.form.description = this.description;
    },
    async onSave() {
      if (this.hasDescriptionChanges) {
        const response = await this.updateDescription({
          form: { description: this.form.description },
          id: this.id
        });

        const isOkey = response.status === 200;

        if (!isOkey) return;
      }

      if (this.hasImagesUploaded) {
        try {
          await this.addImages();
        } catch {
          console.log("error");
          return;
        }
      }

      if (this.hasFilesUploaded) {
        try {
          await this.addFiles(this.prepareFilesForm(this.files));
        } catch {
          console.log("error");
          return;
        }
      }

      this.$emit("onSave");
    },
    prepareForm() {
      return {
        ...this.form
      };
    },
    prepareFilesForm(files) {
      const fd = new FormData();
      files.forEach(item => {
        fd.append("files[]", item.file);
      });
      fd.append("entity_id", this.id);

      return fd;
    },
    filesUploaded({ images, files }) {
      this.images = [...images];
      this.files = [...files];
    },
    async addImages() {
      const promises = [];

      this.images.forEach(item => {
        promises.push(
          this.ordersImageUpload({
            id: this.id,
            form: item.file
          })
        );
      });

      return Promise.all(promises);
    }
  },
  created() {
    this.initForm();
  }
};
</script>